"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHalo = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const getColor = ({ $color, $luminosity }) => {
    // "yellow" uses "night" for AA contrast ratio
    return $luminosity === "high" || $color === "yellow"
        ? "var(--ds-color-night)"
        : "var(--ds-color-white)";
};
const getBackgroundColor = ({ $color = "red", $luminosity, }) => {
    const isHighLum = $luminosity === "high";
    if ($color === "greyscale") {
        return isHighLum ? "var(--ds-color-silver)" : "var(--ds-color-zinc)";
    }
    // "purple" need to use 130 for AA contrast ratio
    const colorLowLum = $color === "purple" ? 130 : 100;
    return isHighLum
        ? `var(--ds-color-${$color}-25)`
        : `var(--ds-color-${$color}-${colorLowLum})`;
};
exports.StyledHalo = styled_components_1.default.span `
    /** layout */
    display: inline-flex;

    /** visual */
    background-color: ${getBackgroundColor};
    border-radius: 9999px;
    padding: 0.25rem;

    /* Styling children (ie: Icon) */
    path {
        fill: ${getColor};
    }
`;
//# sourceMappingURL=Halo.styled.js.map